import type {
  TMonths,
  TGetFormattedTime,
  TGetTimeAndDateByWord,
  TGetTimeAndDate,
  TGetFormattedDate,
  TGetDateText,
} from '~/types/utils/date';

export const months: TMonths = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

const getFormattedTime: TGetFormattedTime = (unixTimeStamp) => {
  const date = new Date(unixTimeStamp * 1000);
  const hours = date.getHours();
  const minutes = '0' + date.getMinutes();
  return hours + ':' + minutes.substr(-2);
};

const getTimeAndDateByWord: TGetTimeAndDateByWord = (unixTimeStamp, formattedTime) => {
  const msInOneDay: number = 24 * 60 * 60 * 1000;
  const now: Date = new Date();
  const nowFullYear: number = now.getFullYear();
  const nowMonth: number | string = ('0' + (now.getMonth() + 1)).substr(-2);
  const nowDate: number | string = ('0' + now.getDate()).substr(-2);
  const dayStart: Date = new Date(`${nowFullYear}-${nowMonth}-${nowDate}T00:00:00`); // сегодня полночь
  const dayStartUTS: number = dayStart.getTime();

  const tomorrowStart = new Date(dayStart);
  tomorrowStart.setDate(tomorrowStart.getDate() + 1); // завтра полночь
  const tomorrowStartUTS: number = tomorrowStart.getTime();

  const diff: number = dayStartUTS - unixTimeStamp * 1000;

  if (diff < 0) {
    if (Math.abs(diff) < msInOneDay) {
      return formattedTime + ' Сегодня';
    }

    if (Math.abs(tomorrowStartUTS - unixTimeStamp * 1000) < msInOneDay) {
      return formattedTime + ' Завтра';
    }
  }

  if (diff > 0 && diff <= msInOneDay) {
    return formattedTime + ' Вчера';
  }

  return '';
};

const getTimeAndDate: TGetTimeAndDate = (unixTimeStamp, formattedTime) => {
  const dateByWord = getTimeAndDateByWord(unixTimeStamp, formattedTime);
  if (dateByWord) {
    return dateByWord;
  }

  const newsItemDate: Date = new Date(unixTimeStamp * 1000);
  const now: Date = new Date();

  return `${newsItemDate.getDate()} ${months[newsItemDate.getMonth()]} ${
    now.getFullYear() === newsItemDate.getFullYear() ? '' : newsItemDate.getFullYear()
  }`;
};

export const getFormattedDate: TGetFormattedDate = (unixTimeStamp) => {
  const formattedTime = getFormattedTime(unixTimeStamp);
  return getTimeAndDate(unixTimeStamp, formattedTime);
};

export const getDateText: TGetDateText = (timestamp) => {
  const articleFullDate = new Date(timestamp * 1000);
  const currentFullDate = new Date();
  let hours = articleFullDate.getHours() as number | string;
  let minutes = articleFullDate.getMinutes() as number | string;
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;

  if (articleFullDate.toLocaleDateString() === currentFullDate.toLocaleDateString()) {
    return `${hours}:${minutes}`;
  }

  if (articleFullDate.getFullYear() === currentFullDate.getFullYear()) {
    const articleMonth = articleFullDate.getMonth();
    const currentMonth = currentFullDate.getMonth();
    const articleDay = articleFullDate.getDate() + 1;
    const currentDay = currentFullDate.getDate();

    if (articleMonth === currentMonth && articleDay === currentDay) {
      return 'Вчера';
    }

    return `${articleFullDate.getDate()} ${months[articleFullDate.getMonth()]}`;
  }
  return getFormattedDate(timestamp);
};

export function getUTCDateFromTimestamp(timestamp: number): string {
  return new Date(timestamp * 1000).toUTCString();
}

export function getTimeStampFromUTCDate(UTCDate: string | undefined): number | null {
  return UTCDate ? Date.parse(UTCDate) / 1000 : null;
}

export function getISODateString(d: Date): string {
  function pad(number: number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  return (
    d.getUTCFullYear() +
    '-' +
    pad(d.getUTCMonth() + 1) +
    '-' +
    pad(d.getUTCDate()) +
    'T' +
    pad(d.getUTCHours()) +
    ':' +
    pad(d.getUTCMinutes()) +
    ':' +
    pad(d.getUTCSeconds()) +
    '+00:00'
  );
}
